export default __webpack_public_path__ + "static/bc_hu_1-7e069cfeb33e7043d37728eccbf8a507.mp4";